/**
 * `not saved`, and why — one chip for the five Setup tabs (CU-869ffwj7a).
 *
 * Three states, by priority `refused > stalled > reason`:
 *
 * - **refused** (`{ message, status }`): the server turned this row down
 *   (a 4xx). Red, with a "!" so colour is not the only difference, and the
 *   server's own words in the title. It is held until the row changes —
 *   there is no retry button because retrying a 4xx by hand is the loop
 *   the chip exists to stop.
 * - **stalled** (boolean): the server did not answer (5xx, network). Amber;
 *   the row goes again with the operator's next edit.
 * - **reason** (string): the tab's own "complete the row" sentence, the
 *   amber Price limits had alone until now. Matrices, Rate cards and
 *   Tethering were holding incomplete rows in silence.
 *
 * Renders nothing when none applies. Native `title` like every row help in
 * the module, never a MUI Tooltip.
 */
import React from 'react'
import { Chip } from '@mui/material'
import { ErrorOutline as ErrorIcon } from 'Pages/DsRepricing/@components/icons'
import { toneChipSx } from 'Pages/DsRepricing/@components/tones'

export const STALLED_TEXT = 'The server did not answer. Your change is kept here and sent again with your next edit.'

export function refusedText(refused) {
	return `The server refused this row: ${refused?.message || 'unknown error'}\nChange the row and it is sent again.`
}

export default function UnsavedChip({ refused, stalled, reason, sx }) {
	let title
	if (refused) title = refusedText(refused)
	else if (stalled) title = STALLED_TEXT
	else if (reason) title = reason
	else return null
	const red = !!refused
	return (
		<Chip size="small" label="not saved" title={title} aria-label={title}
		      icon={red ? <ErrorIcon sx={{ fontSize: 13 }}/> : undefined}
		      sx={{ ...toneChipSx(red ? 'err' : 'warn'), mr: 0.5, ...sx }}/>
	)
}
